import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import Joyride from 'react-joyride';
import { LEARN_TIP } from '../utils/testing/TestIDs';
import LearnTip from './LearnTip';
import { LearnTipModal } from './LearnTipModal';
import './styles.css';

var LearnTips = function LearnTips(_ref) {
  var steps = _ref.steps,
      handleComplete = _ref.handleComplete,
      run = _ref.run,
      className = _ref.className,
      _ref$disableScrolling = _ref.disableScrolling,
      disableScrolling = _ref$disableScrolling === void 0 ? false : _ref$disableScrolling;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var updatedSteps = steps.map(function (step, index) {
    return {
      title: step.title,
      content: step.body,
      placement: step.placement,
      textAlign: 'left',
      target: step.target,
      badgeText: step.badgeText,
      badgeIcon: step.badgeIcon,
      dataTestId: step.dataTestId || LEARN_TIP,
      disableBeacon: index === 0,
      isFixed: true,
      width: step.width,
      offset: 0,
      backgroundImageUrl: step.backgroundImageUrl,
      tipAdjustment: step.tipAdjustment,
      pointerAdjustment: step.pointerAdjustment,
      showButtons: step.showButtons === undefined ? true : step.showButtons,
      spotlightPadding: step.spotlightPadding || 0,
      styles: {
        spotlight: {
          borderRadius: step.borderRadius || '0px'
        }
      }
    };
  });

  var handleJoyrideCallback = function handleJoyrideCallback(props) {
    setActiveStep(props.index);
    handleComplete === null || handleComplete === void 0 ? void 0 : handleComplete(props);
  };

  return /*#__PURE__*/React.createElement(Joyride, {
    run: run,
    steps: updatedSteps,
    beaconComponent: undefined,
    callback: handleJoyrideCallback,
    continuous: true,
    disableOverlayClose: true,
    disableScrolling: disableScrolling,
    scrollOffset: 800,
    tooltipComponent: function tooltipComponent(props) {
      return /*#__PURE__*/React.createElement(LearnTip, _extends({
        className: className
      }, props, {
        activeStep: activeStep
      }));
    },
    floaterProps: {
      disableFlip: true,
      disableAnimation: true
    },
    styles: {
      options: {
        zIndex: 2000000,
        spotlightShadow: 'none'
      },
      overlay: {
        backgroundColor: 'rgba(25, 25, 25, 0.5)'
      }
    }
  });
};

export { LearnTips, LearnTipModal };